export const ANALYSIS_QUOTES_LABELS = {
  markdownFallbackTitle: 'Evidence',
  documentFallbackTitle: 'Document',
} as const
